export default {
  title: 'Pay whenever you are ready',
  description: 'Payment can be done anytime, during or after the meal. If you don’t pay your check before leaving, the restaurant may process the total and add extra charges as a fine.',
};